import { Datasheet } from "@/api/datasheets";
import { InspectorRow, InspectorWeld } from "@/api/rbi";
import { Project } from "@/api/project";
import { SubProject } from "@/api/subProject";

export type WeldListFilters = {
  onlyWeldsNotMade: boolean;
  onlyWeldsReadyForNdt: boolean;
  onlyRepairWelds: boolean;
};

export type InspectorState = {
  project?: Project;
  subProject?: SubProject;
  datasheet?: Datasheet;
  welds: InspectorWeld[];
  inspections: InspectorRow[];
  filters: WeldListFilters;
};

export const defaultFilters: WeldListFilters = {
  onlyWeldsNotMade: false,
  onlyWeldsReadyForNdt: true,
  onlyRepairWelds: false,
};

export const defaultState: InspectorState = {
  welds: [],
  inspections: [],
  filters: defaultFilters,
};

export type StateType = "Project" | "SubProject" | "Datasheet" | "Welds" | "Inspections" | "Filters";
